<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            form-tabs(
                v-if="templateHasDays || homeworkHasAtLeastTwoDates",
                elements-type="homework"
                :tabs-number="tabsNumber",
                :same-settings-are-active="false",
                :disable-name-change="true"
                :custom-tab-names="customTabNames"
                @setCurrentTab="num => currentHomeworkTab = num"
                @wrongTabsAmount="equalizeDaysToDates"
            )
            .form__field(v-if="gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
                .form__field-body
                    cs-multiselect(
                        :multiple="gameMode === 'course'",
                        :options='gameModes',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='mode',
                        label='name',
                        :hide-selected="gameMode === 'course'",
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseGameWithTime')",
                        v-model='selectedGameMode',
                        @select="selectGameMode($event.mode)",
                        :searchable="false"
                    )
            .form__field(v-if="params.mode !== 'static' && gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfWords') }}
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_onScreen') }}
                .form__field-body
                    cs-spin-input(
                        v-model="params.settings.words"
                        :min="1"
                        :max="7"
                        @increase="params.settings.words++"
                        @decrease="params.settings.words--"
                    )
            .form__field(v-if="params.withTime && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_speed') }}
                .form__field-body
                    cs-multiselect(
                        :options="speeds"
                        v-model="params.speed"
                        :placeholder="speedLabel(params.speed)"
                        :custom-label="speedLabel"
                        :multiple="false"
                        :allow-empty="false"
                    )
            .form__field(v-if="gameMode !== 'generator-settings' && gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_textInput') }}
                .form__field-body
                    div
                        span(v-if="user.type !== 'student'")
                            a.link(@click.prevent="showManualInputModal = true")
                                | {{ changeTextLink }}
                            span &nbsp; {{ $i18n.t('games.games_or') }} &nbsp;
                        a.link(@click.prevent="showSelectTextModal = true") {{ selectString }}
                    div.source-text(v-if="params.sourceText") {{ params.textLabel }}
            .form__field
                label.form__label(v-if="!params.allQuestions && gameMode !== 'generator-settings'")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_allQuestions') }}
                .form__field-body
                    cs-checkbox(
                        :checked="params.settings.allQuestions"
                        v-model="params.settings.allQuestions"
                        :disabled="isAllQuestionsSettingDisabled"
                    )
            .form__field(v-if="!params.withTime && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_withoutEndLetters') }}
                .form__field-body
                    cs-checkbox(
                        :checked="params.settings.endLetters"
                        @change="setSentenceSettings('endLetters', true)"
                        :disabled="isEndLettersSettingDisabled"
                    )
            .form__field(v-if="!params.withTime && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_withoutCentralLetters') }}
                .form__field-body
                    cs-checkbox(
                        :checked="params.settings.centralLetters"
                        @change="setSentenceSettings('centralLetters', true)"
                        :disabled="isCentralLettersSettingDisabled"
                    )
            .form__field(v-if="!params.withTime && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_withoutWord') }}
                .form__field-body
                    cs-checkbox(
                        v-model="params.settings.withoutWord"
                        :disabled="isWithoutWordSettingDisabled"
                    )
            .form__field(v-if="!params.withTime && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_invertText') }}
                .form__field-body
                    cs-checkbox(
                        :checked="params.settings.invertText"
                        @change="setTextSettings('invertText', true)"
                        :disabled="isInvertTextSettingDisabled"
                    )
            .form__field(v-if="!params.withTime && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_withoutVowels') }}
                .form__field-body
                    cs-checkbox(
                        v-model="params.settings.withoutVowels",
                        :disabled="isWithoutVowelsSettingDisabled"
                    )
            .form__field(v-if="!params.withTime && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_solidText') }}
                .form__field-body
                    cs-checkbox(
                        v-model="params.settings.solidText",
                        :disabled="isSolidTextSettingDisabled"
                    )
            metronome-setting(
                :game-mode="gameMode",
                :metronome-speed="+params.metronomeSpeed",
                @updateSpeed="updateMetronomeSpeed"
            )
            divider
            .settings(v-if="gameMode === 'course' || selectedGameMode.mode === 'static'")
                .row.settings-row(v-if="gameMode !== 'course' && (params.settings.centralLetters || params.settings.endLetters)")
                    .settings-header
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_withoutLetters') }}
                    .form-container__setting.form-container__select
                        cs-multiselect(
                            v-model='params.settings.letters',
                            :options="[1, 2]",
                            :multiple="false",
                            :searchable="true",
                            :allow-empty="false",
                            :show-labels="false",
                            :placeholder="String(params.settings.letters)"
                        )
                .row.settings-row
                    .settings-header
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfAnagrams') + $i18n.t('trainer.trainer_gameFormSetting_inSentence') }}
                    .form-container__setting
                        template(v-for="number in words")
                            cs-checkbox.setting__checkbox(
                                @click.native.prevent="setSettings('anagrams', number)",
                                :checked="isChecked(number, 'anagrams')"
                                :value='number',
                                :id='number.label',
                                :disabled="isDisabled(number, 'anagrams')"
                            ) {{ number.label }}
                .row.settings-row
                    .settings-header
                        | {{ $i18n.t('trainer.trainer_gameFormSettings_amountOfMirrorWords') + $i18n.t('trainer.trainer_gameFormSetting_inSentence') }}
                    .form-container__setting
                        template(v-for="number in words")
                            cs-checkbox.setting__checkbox(
                                @click.native.prevent="setTextSettings('mirrorText', number)",
                                :checked="isChecked(number, 'mirrorText')"
                                :value='number',
                                :id='number.label',
                                :disabled="isDisabled(number, 'mirrorText')"
                            ) {{ number.label }}
            divider(v-if="gameMode === 'course' || selectedGameMode.mode === 'static'")
            slot(v-if="customTabNames.length === 0", name='parameters')
            slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='handleGameSave' :disabled="disabledAsNotHavingSource")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else)
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='handleGameSave' :disabled="disabledAsNotHavingSource")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
        cs-loader(v-else)
        cs-modal(v-if="showManualInputModal", @close="closeManualInputModal")
            div(slot="header") {{ $i18n.t('trainer.trainer_gameFormSetting_manualInput_modalTitle') }}
            .trainer-modal-content__settings
                .trainer-modal-content__setting
                    span.trainer-modal-content__language-selector(v-text="$i18n.t('trainer.trainer_gameFormSetting_textLanguage')")
                    cs-multiselect.text-settings(
                        :multiple='false'
                        :options='locales'
                        :show-labels='false'
                        :allow-empty='false'
                        :custom-label='getLocaleName'
                        v-model='params.language'
                        :searchable='false'
                        v-validate="'required'"
                        name='locale'
                        :data-vv-as="$i18n.t('user.user_form_languageDataVvSs')"
                    )
                .trainer-modal-content__setting
                    cs-input(
                        type="text",
                        v-model="params.textLabel",
                        :placeholder="$i18n.t('trainer.trainer_textsModal_textLabel')"
                    )
                .trainer-modal-content__setting
                    textarea.textarea.input-area.trainer-modal-content__textarea(
                        v-model="params.sourceText",
                        :placeholder="$i18n.t('trainer.trainer_textsModal_textInput')"
                    )
                .question-answers-block
                    .question-block(v-model="params.questions", v-for="(question, questionIndex) in params.questions")
                        .question-block__input
                            svg-icon.delete-question-icon(
                                size="big",
                                name="cancel",
                                @click.native.prevent="deleteQuestion(questionIndex)",
                                v-if="params.questions.length !== 1"
                            )
                            textarea.input-area.trainer-modal-content__textarea_small(
                                v-model="question.content",
                                :placeholder="$i18n.t('trainer.trainer_gameFormSetting_question')"
                            )
                        .answers-block
                            .answer-block(v-model="question.answers", v-for="(answer, answerIndex) in question.answers")
                                .answer-block__items
                                    .right-answer-checkbox
                                        cs-checkbox(
                                            :checked="answer.correct",
                                            v-model="answer.correct",
                                            @click.native.prevent="setRightAnswer(answer, questionIndex)",
                                        )
                                    .answer-block__input
                                        svg-icon.delete-answer-icon(
                                            size="big",
                                            name="cancel",
                                            @click.native.prevent="deleteAnswer(answerIndex, questionIndex)"
                                            v-if="question.answers.length > 2 && !answer.correct"
                                        )
                                        textarea.input-area.trainer-modal-content__textarea_small(
                                            v-model="answer.content",
                                            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_answer')"
                                        )
                            .trainer-modal-button.answer-button
                                .select-correct-answer-text
                                    | {{$i18n.t('trainer.trainer_gameFormSetting_selectCorrectAnswer')}}
                                .add-answer-button
                                    cs-button(@click="addAnswer(questionIndex)",  color="blue", pattern="primary-outline")
                                        | {{$i18n.t('trainer.trainer_gameFormSetting_addAnswer')}}
                    .trainer-modal-button.add-question-button
                        cs-button(@click="addQuestion", color="blue", pattern="primary-outline")
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_addQuestion') }}
                    divider
                    div
                        .trainer-modal__save-to-database(v-if="isUserAbleToSaveToDB")
                            cs-checkbox(
                                @click.native.prevent="saveToDB = !saveToDB",
                                v-model="saveToDB",
                                :checked="saveToDB",
                                :disabled="editText"
                            )
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_saveTextToDataBaseAsNew') }}
                        .trainer-modal__save-to-database(v-if="canUserEditText")
                            cs-checkbox(
                                @click.native.prevent="editText = !editText",
                                v-model="editText",
                                :checked="editText",
                                :disabled="saveToDB"
                            )
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_editText') }}
                        .save-text-relation-selector(v-if="saveToDB || editText")
                            cs-multiselect.text-settings__select(
                                :multiple='false'
                                :options='typesOfRelations'
                                :show-labels='false'
                                :allow-empty='false'
                                :custom-label='getRelationName'
                                :placeholder="$i18n.t('trainer.trainer_textsRelationSelector')"
                                v-model='relation'
                                :searchable='false'
                                v-validate="'required'"
                                name='relation'
                                :data-vv-as="$i18n.t('trainer.trainer_textsRelationSelector')"
                            )
                            cs-multiselect.text-settings__select(
                                :multiple="true",
                                :options="relationItems",
                                :show-labels="false",
                                label="name",
                                track-by="id",
                                :loading="loadingRelationItems",
                                :placeholder="relationItemsPlaceholder",
                                v-model="selectedRelationItems",
                                :disabled="!relationItems.length",
                                @open="getRelationItems"
                            )
                                span(slot="noResult") {{ $i18n.t('fields.fields_gradeNotFound') }}
            div.trainer-modal__footer.trainer-modal-button
                cs-button(
                    @click="showManualInputModal = false",
                    :disabled="checkFields"
                ) {{ $i18n.t('trainer.trainer_gameFormSetting_saveChanges') }}
        cs-modal(v-if="showTextSettings", @close="closeTextSettings")
            div(slot="header") {{ $i18n.t('trainer.trainer_gameFormSetting_accessSettings') }}
            .trainer-modal-content(v-if="user.isSuperadmin")
                .trainer-modal-content__text-settings
                    cs-multiselect.text-settings__select(
                        :multiple='false'
                        :options='typesOfRelations'
                        :show-labels='false'
                        :allow-empty='true'
                        :custom-label='getRelationName'
                        :placeholder="$i18n.t('trainer.trainer_textsRelationSelector')"
                        v-model='relation'
                        :searchable='false'
                        v-validate="'required'"
                        name='relation'
                        :data-vv-as="$i18n.t('trainer.trainer_textsRelationSelector')"
                    )
                    cs-multiselect.text-settings__select(
                        :multiple="true",
                        :options="relationItems",
                        :show-labels="false",
                        label="name",
                        track-by="id",
                        :loading="loadingRelationItems",
                        :placeholder="relationItemsPlaceholder",
                        v-model="selectedRelationItems",
                        :disabled="!relation || !relationItems.length",
                        @open="getRelationItems"
                    )
                        span(slot="noResult") {{ $i18n.t('fields.fields_gradeNotFound') }}
                .trainer-modal-content__footer
                    cs-button.trainer-modal-content__footer-button(@click="backToShowSelectTextModal")
                        | {{ $i18n.t('trainer.trainer_browseGames_back') }}
                    cs-button.trainer-modal-content__footer-button(@click="updateTextSettings", :disabled="relation && !selectedRelationItems.length")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveChanges') }}
        confirm-delete-modal(
            v-if="showDeleteTextModal",
            @close="showDeleteTextModal = false"
            @delete="deleteText"
        ) {{ " " + $i18n.t('list.list_templatePreview_thisText') }}
            div(slot="header") {{ $i18n.t('modal.modal_confirmDelete_confirmation') }}
        cs-modal(v-if="showSelectTextModal", @close="closeSelectTextModal")
            div(slot="header") {{ $i18n.t('trainer.trainer_gameFormSetting_selectModal_modalTitle') }}
            .trainer-modal-content
                .trainer-modal-content__settings
                    .trainer-modal-content__setting
                        span.trainer-modal-content__amount-of-words-selector
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfWords') }}:
                        cs-multiselect.text-settings(
                            :multiple='false'
                            :options='amountsOfWords'
                            :show-labels='false'
                            :allow-empty='false'
                            :custom-label="getAmountOfWordsName"
                            v-model='amountOfWordsInText'
                            :searchable='true'
                            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_selectAmountOfWords')"
                            :data-vv-as="$i18n.t('trainer.trainer_gameFormSetting_amountOfWords')"
                        )
                    .trainer-modal-content__setting(v-if="['admin', 'teacher'].includes(user.type)")
                        .trainer-modal-content__access-selector-buttons
                            cs-button.cs-button-selector(
                                v-for="access in textAccesses"
                                :key="access"
                                pattern="primary-outline"
                                color="blue"
                                @click="selectedTextsAccess = access"
                                :class="{\
                                    'cs-button-selector_active': selectedTextsAccess === access,\
                                }"
                                :disabled="!availableTextsAccesses.includes(access)"
                            )
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_textAccess_' + access) }}
                    .trainer-modal-content__setting
                        .trainer-modal-content__search-input
                            cs-input(
                                :placeholder="$i18n.t('trainer.trainer_gameFormSetting_searchForText')",
                                @input="searchTextByTitle"
                                v-model="searchTextName",
                            )
                            svg-icon.search-icon(size="large", name="search")
                    .trainer-modal-content__setting
                        span.trainer-modal-content__language-selector(v-text="$i18n.t('trainer.trainer_gameFormSetting_textLanguage')")
                        cs-multiselect.text-settings(
                            :multiple='false'
                            :options='locales'
                            :show-labels='false'
                            :allow-empty='false'
                            :custom-label='getLocaleName'
                            v-model='params.language'
                            :searchable='false'
                            v-validate="'required'"
                            name='locale'
                            :data-vv-as="$i18n.t('user.user_form_languageDataVvSs')"
                        )
                .trainer-modal-content__noTextsMessage(
                    v-if="!loadingTextItems && formattedTexts.length === 0",
                    v-text="$i18n.t('trainer.trainer_gameFormSetting_noTexts')"
                )
                v-infinite-scroll(
                    v-else,
                    @bottom="getNextPage",
                    :offset='300'
                    style="max-height: 40vh; overflow-y: scroll;"
                )
                    cs-loader(v-if="loadingTextItems")
                    .trainer-modal-content__text-item(
                        v-else
                        v-for="(text, index) in formattedTexts"
                        :class=`{
                            'trainer-modal-content__text-item_selected': text.content === params.sourceText,
                            'trainer-modal-content__text-item_opened': isTextOpened(index),
                        }`
                    )
                        div.trainer-modal-content__text-item__title(
                            @click="resizeText(index)",
                            :class=`{
                                'trainer-modal-content__text-item__title_selected': text.content === params.sourceText,
                                'trainer-modal-content__text-item__title_closed': !isTextOpened(index)
                            }`
                        )
                            .text-label
                                svg-icon.selected-text-icon(v-if="text.content === params.sourceText", name="circle-check", size="big")
                                | {{ text.label }}
                            .trainer-modal-content__text-item-actions
                                span.trainer-modal-content__text-item-settings(
                                    v-if="user.isSuperadmin",
                                    @click.stop="handleTextSettings(text)",
                                )
                                    svg-icon(size="small", name="cog")
                                span.trainer-modal-content__text-item-delete(
                                    v-if="text.canUserEditText",
                                    @click.stop="handleDeleteText(text)",
                                )
                                    svg-icon(size="largest", name="cancel")
                                span.trainer-modal-content__text-item__resize__box
                                    svg-icon(v-if="!isTextOpened(index)", name="angle-down", size="large")
                                    svg-icon(v-else, name="angle-up", size="large")
                        .text-content(
                            v-if="isTextOpened(index)",
                            :class="{'text-content_selected': text.content === params.sourceText}"
                        )
                            div(@click="handleClickOnText(text)")
                                .trainer-modal-content__text-item__content(v-for="line in lines(text)") {{ line }}
                            div(v-if="user.type !== 'student'")
                                .trainer-modal-content__text-item__questions(
                                    v-for="(question, questionIndex) in text.questions",
                                    :class="{'trainer-modal-content__text-item__questions_last': questionIndex === text.questions.length - 1}"
                                )
                                    .trainer-modal-content__text-item__question
                                        span.question {{ $i18n.t('trainer.trainer_gameFormSetting_question') }}:
                                        |
                                        | {{ question.content }}
                                    .trainer-modal-content__text-item__answers(v-for="answer in question.answers")
                                        .trainer-modal-content__text-item__answer
                                            .trainer-modal-content__text-item__answer__content
                                                span.answer {{ $i18n.t('trainer.trainer_gameFormSetting_answer') }}:
                                                |
                                                | {{ answer.content }}
                                            .trainer-modal-content__text-item__answer__correct(v-if="answer.correct")
                                                span.trainer-modal-content__text-item__answer__correct__box
                                                    svg-icon(name="check", size="base")
            .trainer-modal-button(v-if="formattedTexts.length")
                cs-button(@click="showSelectTextModal = false") {{ $i18n.t('trainer.trainer_gameFormSetting_saveChanges') }}
</template>

<script>
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from '../../../utils/trainer/getInitParameters';
    import { getFormattedDate } from '../../../utils/getFormattedDate';
    import { mapState } from 'vuex';
    import { cloneDeep, find, debounce } from 'lodash';
    import IntervalConfig from '../../trainer/configs/IntervalConfig';
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';
    import textsGameItems from '../../../api/games/textsGameItems';
    import availableLocales from '../../../utils/trainer/availableLocales';
    import MetronomeSetting from '../default-settings/MetronomeSetting.vue';
    import SchoolApi from '../../../api/school';
    import GradeApi from '../../../api/grade';
    import FormTabs from '../shared/FormTabs';
    import ConfirmDeleteModal from '../../../modals/ConfirmDeleteModal';
    const CAPABLE_USER_TYPES = ['admin', 'teacher'];
    const FREE_GAME = 'free-game';
    const SECONDS_IN_MINUTE = 60;

    export default {
        components: {
            FormTabs,
            ConfirmDeleteModal,
            MetronomeSetting,
        },
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex',
        ],
        mixins: [GameFormMixin, multiplayerFormMixin],
        data() {
            return {
                locales: availableLocales.locales,
                localeNames: availableLocales.localeNames,
                gameModes: [
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_static'),
                        mode: 'static',
                    },
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_disappear'),
                        mode: 'disappear',
                    },
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_appear'),
                        mode: 'appear',
                    },
                ],
                words: [
                    {
                        label: '1',
                        mode: 1,
                    },
                    {
                        label: '2',
                        mode: 2,
                    },
                    {
                        label: '3',
                        mode: 3,
                    },
                    {
                        label: '4',
                        mode: 4,
                    },
                    {
                        label: '5',
                        mode: 5,
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_allSentence'),
                        mode: 'all',
                    },
                ],
                namesForDays: ['1', '2', '3', '4', '5', '6', '7', '8'],
                seconds: IntervalConfig.secondsForShutter,
                selectedGameMode: null,
                params: null,
                showManualInputModal: false,
                showSelectTextModal: false,
                showDeleteTextModal: false,
                texts: [],
                saveToDB: false,
                editText: false,
                selectedTextId: null,
                canUserEditText: null,
                openedTexts: [],
                courseParameters: null,
                relation: '',
                typesOfRelations: ['grade', 'school'],
                relations: {
                    grade: this.$i18n.t('homework.homework_create_grade'),
                    school: this.$i18n.t('homework.homework_create_school'),
                },
                loadingRelationItems: false,
                loadingTextItems: false,
                relationItems: [],
                selectedRelationItems: [],
                showTextSettings: false,
                selectedText: null,
                textAccesses: ['everyone', 'mine'],
                availableTextsAccesses: [],
                selectedTextsAccess: 'everyone',
                searchTextName: '',
                amountOfWordsInText: 'any',
                amountsOfWords: ['any', '1-50', '51-100', '101-150', '151-200', '201-250'],
                currentHomeworkTab: 1,
                page: 1,
                lastPage: null,
            };
        },
        mounted() {
            textsGameItems
                .getItemsByRequest({ locale: this.user.locale, page: this.page, access: this.selectedTextsAccess })
                .then(data => {
                    this.texts = data.data;
                    this.lastPage = data.lastPage;
                    this.texts.forEach(text => {
                        text.questions = JSON.parse(text.questions);
                    });
                    if (this.gameMode === FREE_GAME) {
                        let paramsArray = this.$store.state.trainer.paramsArray;
                        if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                            this.paramsArray = cloneDeep(paramsArray);
                            this.$emit('playersNumber', this.paramsArray.length);
                            this.params = this.paramsArray[0];
                        } else if (this.gamesParameters) {
                            this.courseParameters = cloneDeep(this.gamesParameters[this.slug]);
                            this.$set(
                                this,
                                'params',
                                cloneDeep(
                                    getInitParameters({
                                        slug: this.slug,
                                        parameters: {
                                            default: cloneDeep(this.gamesParameters[this.slug]),
                                        },
                                    })
                                )
                            );
                            this.setDefaultParameters();
                        } else {
                            this.params = cloneDeep(TrainerGames.games).find(
                                item => item.slug === this.slug
                            ).parameters.default;
                        }
                    } else {
                        this.setInitParams(this.getKey(this.usersIds));
                    }
                    if (this.gameMode !== 'course') {
                        Array.isArray(this.params.mode) && (this.params.mode = this.gameModes[0].mode);
                        this.selectedGameMode = find(this.gameModes, { mode: this.params.mode });
                        this.params.language = this.user.locale;
                    } else {
                        this.selectedGameMode =
                            typeof this.params.mode === 'object'
                                ? this.gameModes.filter(item => this.params.mode.includes(item.mode))
                                : [this.gameModes[0]];
                    }
                    if (this.gamesParameters) {
                        this.courseParameters = cloneDeep(this.gamesParameters[this.slug]);
                        this.setDefaultParameters();
                    }
                    const currentAmountOfDays = this.homework?.dates
                        ? this.homework.dates.length
                        : this.homework?.chosenDaysAmount;

                    if (this.params && this.paramsArray?.length !== currentAmountOfDays) {
                        if (this.homework?.chosenDaysAmount > 1 || this.params.settings.days) {
                            this.homework?.games.forEach(game => {
                                if (game.slug === 'Texts') {
                                    const searchedGameIndex = this.homework.games.findIndex(
                                        homeworkGame => homeworkGame.id === game.id
                                    );
                                    const searchedParamsIndex = this.paramsArray.indexOf(param => param.id === game.id);
                                    this.paramsArray[searchedParamsIndex] = this.homework.games[
                                        searchedGameIndex
                                    ].parameters.default;
                                }
                            });

                            if (this.paramsArray.length !== this.homework?.chosenDaysAmount) {
                                while (this.paramsArray.length < this.homework?.chosenDaysAmount) {
                                    let counter = 0;
                                    this.paramsArray.push(cloneDeep(this.params));
                                    this.params = this.paramsArray[counter];
                                    counter++;
                                }

                                while (this.paramsArray.length > currentAmountOfDays) {
                                    this.cropParamsArrayToNeededLength();
                                }
                            }
                        }
                        if (this.homework?.dates?.length > 1) {
                            while (this.paramsArray.length < currentAmountOfDays) {
                                this.paramsArray.push(
                                    cloneDeep(
                                        getInitParameters({
                                            slug: this.slug,
                                            parameters: {
                                                default: cloneDeep(this.gamesParameters[this.slug]),
                                            },
                                        })
                                    )
                                );
                                const paramsArrayLastIndex = this.paramsArray.length - 1;
                                this.paramsArray[paramsArrayLastIndex].dueDate = getFormattedDate(
                                    this.homework.dates[paramsArrayLastIndex],
                                    'YYYY-MM-DD'
                                );
                            }
                            while (this.paramsArray.length > currentAmountOfDays) {
                                this.cropParamsArrayToNeededLength();
                            }
                            this.params = this.paramsArray[0];
                        }
                    }
                });
            textsGameItems.getAvailableTextsAccesses().then(data => {
                this.availableTextsAccesses = data.availableTextsAccesses;
            });
        },
        updated() {
            this.params &&
                this.gameMode !== 'course' &&
                (this.selectedGameMode = find(this.gameModes, { mode: this.params.mode }));
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
            fromWordsAmount() {
                return this.amountOfWordsInText.split('-')[0];
            },
            toWordsAmount() {
                return this.amountOfWordsInText.split('-')[1];
            },
            tabsNumber() {
                return this.templateHasDays ? this.params.settings.days : this.homework.dates.length;
            },
            homeworkHasAtLeastTwoDates() {
                return this.homework?.dates?.length > 1;
            },
            templateHasDays() {
                return this.params.settings.days > 1;
            },
            isEndLettersSettingDisabled() {
                return (
                    (this.courseParameters && !this.courseParameters.settings.endLetters) ||
                    (this.gameMode !== 'course' &&
                        (this.params.settings.solidText || this.params.settings.withoutVowels))
                );
            },
            isCentralLettersSettingDisabled() {
                return (
                    (this.courseParameters && !this.courseParameters.settings.centralLetters) ||
                    (this.gameMode !== 'course' &&
                        (this.params.settings.solidText || this.params.settings.withoutVowels))
                );
            },
            isWithoutWordSettingDisabled() {
                return (
                    (this.courseParameters && !this.courseParameters.settings.withoutWord) ||
                    (this.gameMode !== 'course' &&
                        (this.params.settings.solidText || this.params.settings.withoutVowels))
                );
            },
            isInvertTextSettingDisabled() {
                return this.courseParameters && !this.courseParameters.settings.invertText;
            },
            isWithoutVowelsSettingDisabled() {
                return (
                    (this.courseParameters && !this.courseParameters.settings.withoutVowels) ||
                    (this.gameMode !== 'course' && this.params.settings.solidText)
                );
            },
            isSolidTextSettingDisabled() {
                return (
                    (this.courseParameters && !this.courseParameters.settings.solidText) ||
                    (this.gameMode !== 'course' && this.params.settings.withoutVowels)
                );
            },
            isAllQuestionsSettingDisabled() {
                return this.courseParameters && !this.courseParameters.settings.allQuestions;
            },
            formattedTexts() {
                const regex = /\(\d+\s+[а-яА-Я]+\)/gi;
                this.filteredTexts.forEach(text => {
                    if (text && text.label && text.label.search(regex) !== -1) {
                        text.label = text.label.replace(
                            regex,
                            `(${text.amountOfWords} ${this.$i18n.tc(
                                'trainer.trainer_textForm_words',
                                +text.amountOfWords
                            )})`
                        );
                    } else {
                        text.label += ` (${text.amountOfWords} ${this.$i18n.tc(
                            'trainer.trainer_textForm_words',
                            +text.amountOfWords
                        )})`;
                    }
                });
                return this.filteredTexts;
            },
            filteredTexts() {
                return this.texts
                    .filter(text => {
                        if (text.locale === this.params.language) {
                            if (this.selectedTextsAccess === 'mine') {
                                return text.grades && text.grades.length;
                            }
                            if (this.selectedTextsAccess === 'everyone') {
                                return (
                                    (text.schools && text.schools.length) ||
                                    !(text.grades && text.grades.length && text.schools && text.schools.length)
                                );
                            }
                        }
                    })
                    .filter(text => {
                        if (this.searchTextName) {
                            let regExp = new RegExp(this.searchTextName + '.*$', 'i');
                            return text && text.label && text.label.search(regExp) !== -1;
                        }
                        return true;
                    })
                    .filter(text => {
                        if (this.amountOfWordsInText && this.amountOfWordsInText !== 'any') {
                            let numbers = this.amountOfWordsInText.split('-').map(number => +number);
                            return this.isBetween(text.amountOfWords, ...numbers);
                        }
                        return true;
                    });
            },
            selectString() {
                let str = this.$i18n.t('games.games_gameSettings_selectFromLoaded');
                return this.user.type === 'student' ? str.charAt(0).toUpperCase() + str.slice(1) : str;
            },
            disabledAsNotHavingSource() {
                if (this.gameMode === 'course') {
                    return false;
                }
                return this.paramsArray.some(params => {
                    if (params.mode === 'static' && params.sourceText) {
                        return false;
                    }
                    const paramsArrayIsBiggerThanOne = this.paramsArray.length > 1;
                    return !params.settings.words || paramsArrayIsBiggerThanOne
                        ? !params.sourceText
                        : !this.params.sourceText.length;
                });
            },
            intervalName() {
                return this.params.mode === 'appear' ? 0 : 1;
            },
            checkFields() {
                let missingQuestionOrAnswer = this.params.questions.some(question => {
                    if (!question.content) {
                        return true;
                    } else {
                        return question.answers.some(answer => {
                            if (!answer.content) {
                                return true;
                            }
                        });
                    }
                });
                if (!this.saveToDB || this.user.isSuperadmin) {
                    return missingQuestionOrAnswer;
                } else {
                    return !this.selectedRelationItems.length || missingQuestionOrAnswer;
                }
            },
            isUserAbleToSaveToDB() {
                return CAPABLE_USER_TYPES.includes(this.user.type);
            },
            speeds() {
                return this.seconds.map(second => {
                    return {
                        value: Math.round((this.params.settings.words / second) * SECONDS_IN_MINUTE),
                        showTime: second,
                    };
                });
            },
            relationItemsType() {
                if (this.relationItems.length) {
                    return this.relationItems[0].access ? 'grade' : 'school';
                }
                return 'grade';
            },
            relationItemsPlaceholder() {
                if (this.relation) {
                    return this.$i18n.t('trainer.trainer_textsRelation_items', {
                        itemType:
                            this.relation === 'school'
                                ? this.$i18n.t('declination.declination_school_add')
                                : this.$i18n.t('declination.declination_grade_add'),
                    });
                }
                return this.$i18n.t('trainer.trainer_textsRelationSelector');
            },
            customTabNames() {
                if (this.homework && this.homework.dates?.length > 1) {
                    return this.homework.dates
                        .slice()
                        .reverse()
                        .map(date => {
                            let dateAsClassObject = new Date(date);
                            const [day, month] = [dateAsClassObject.getDate(), dateAsClassObject.getMonth() + 1];
                            const addLeadingZeros = number => {
                                return number < 10 ? '0' + number : '' + number;
                            };
                            return addLeadingZeros(day) + '.' + addLeadingZeros(month);
                        });
                } else if (this.templateHasDays) {
                    return this.namesForDays;
                }
                return [];
            },
            changeTextLink() {
                return this.params.sourceText
                    ? this.$i18n.t('trainer.trainer_gameFormSetting_changeText')
                    : this.$i18n.t('trainer.trainer_gameFormSetting_manualInput');
            },
        },
        watch: {
            currentHomeworkTab(value) {
                if (value) {
                    this.params = this.paramsArray[value - 1];
                }
            },
            'params.mode': {
                handler(val) {
                    if (this.gameMode !== 'course') {
                        if (val === 'static') {
                            this.params.withTime = false;
                            this.params.settings.words = 1;
                        } else {
                            this.params.withTime = true;
                            this.params.settings.endLetters = false;
                            this.params.settings.withoutWord = false;
                            this.params.settings.centralLetters = false;
                            this.params.settings.invertText = false;
                            this.params.settings.mirrorText = null;
                            this.params.settings.letters = 1;
                            this.params.settings.anagrams = null;
                            this.params.settings.solidText = false;
                            this.params.settings.withoutVowels = false;
                        }
                    }
                },
            },
            'params.language'(val) {
                if (!this.showSelectTextModal) {
                    return;
                }
                this.loadingTextItems = true;
                this.page = 1;
                textsGameItems
                    .getItemsByRequest({
                        locale: val,
                        title: this.searchTextName,
                        page: this.page,
                        access: this.selectedTextsAccess,
                        fromWordsAmount: this.fromWordsAmount,
                        toWordsAmount: this.toWordsAmount,
                    })
                    .then(texts => {
                        this.texts = texts.data;
                        this.texts.forEach(text => {
                            text.questions = JSON.parse(text.questions);
                        });
                        this.loadingTextItems = false;
                    });
            },
            selectedTextsAccess() {
                this.loadingTextItems = true;
                this.page = 1;
                textsGameItems
                    .getItemsByRequest({
                        locale: this.params.language,
                        title: this.searchTextName,
                        page: this.page,
                        access: this.selectedTextsAccess,
                        fromWordsAmount: this.fromWordsAmount,
                        toWordsAmount: this.toWordsAmount,
                    })
                    .then(texts => {
                        this.texts = texts.data;
                        this.texts.forEach(text => {
                            text.questions = JSON.parse(text.questions);
                        });
                        this.loadingTextItems = false;
                    });
            },
            amountOfWordsInText() {
                this.loadingTextItems = true;
                this.page = 1;
                textsGameItems
                    .getItemsByRequest({
                        locale: this.params.language,
                        title: this.searchTextName,
                        page: this.page,
                        access: this.selectedTextsAccess,
                        fromWordsAmount: this.fromWordsAmount,
                        toWordsAmount: this.toWordsAmount,
                    })
                    .then(texts => {
                        this.texts = texts.data;
                        this.texts.forEach(text => {
                            text.questions = JSON.parse(text.questions);
                        });
                        this.loadingTextItems = false;
                    });
            },
            selectedGameMode(value) {
                if (this.gameMode === 'course') {
                    if (!value.find(item => item.mode === 'static')) {
                        this.selectedGameMode.push(this.gameModes.find(item => item.mode === 'static'));
                    }
                    this.params.mode = value.map(item => item.mode);
                }
            },
            'params.withTime': {
                handler(val) {
                    !this.params.speed && val && (this.params.speed = this.speeds && this.speeds[0]);
                    !val && (this.params.speed = null);
                },
            },
            'params.settings.words': {
                handler() {
                    !this.params.speed && (this.params.speed = this.speeds && this.speeds[0]);
                },
            },
            'params.settings.solidText': {
                handler(value) {
                    if (value && this.gameMode !== 'course') {
                        this.params.settings.endLetters = false;
                        this.params.settings.withoutWord = false;
                        this.params.settings.centralLetters = false;
                        this.params.settings.withoutVowels = false;
                    }
                },
            },
            'params.settings.withoutVowels': {
                handler(value) {
                    if (value && this.gameMode !== 'course') {
                        this.params.settings.endLetters = false;
                        this.params.settings.withoutWord = false;
                        this.params.settings.centralLetters = false;
                        this.params.settings.solidText = false;
                    }
                },
            },
            relation() {
                this.selectedRelationItems = [];
                this.getRelationItems();
            },
        },
        methods: {
            getNextPage: debounce(function() {
                if (this.page !== this.lastPage) {
                    this.page++;
                    textsGameItems
                        .getItemsByRequest({
                            locale: this.params.language,
                            title: this.searchTextName,
                            page: this.page,
                            access: this.selectedTextsAccess,
                            fromWordsAmount: this.fromWordsAmount,
                            toWordsAmount: this.toWordsAmount,
                        })
                        .then(texts => {
                            texts.data.forEach(text => {
                                text.questions = JSON.parse(text.questions);
                            });
                            this.page === 1 ? (this.texts = texts.data) : this.texts.push(...texts.data);
                        });
                }
            },1000),
            debouncedTextItemsSearch: debounce(function() {
                this.page = 1;
                textsGameItems
                    .getItemsByRequest({
                        locale: this.params.language,
                        title: this.searchTextName,
                        page: this.page,
                        access: this.selectedTextsAccess,
                        fromWordsAmount: this.fromWordsAmount,
                        toWordsAmount: this.toWordsAmount,
                    })
                    .then(data => {
                        this.lastPage = data.lastPage;
                        this.texts = data.data;
                        this.texts.forEach(text => {
                            text.questions = JSON.parse(text.questions);
                        });
                        this.loadingTextItems = false;
                    });
            }, 1000),
            searchTextByTitle() {
                this.loadingTextItems = true;
                this.debouncedTextItemsSearch();
            },
            cropParamsArrayToNeededLength() {
                this.paramsArray.pop();
                this.params = this.paramsArray[0];
            },
            equalizeDaysToDates(datesAmount) {
                this.params.settings.days = datesAmount;
            },
            isBetween(number, leftEdge, rightEdge) {
                return number >= leftEdge && number <= rightEdge;
            },
            backToShowSelectTextModal() {
                this.showSelectTextModal = true;
                this.showTextSettings = false;
            },
            updateTextSettings() {
                textsGameItems
                    .updateTextData({
                        id: this.selectedText.id,
                        relation: this.relation,
                        selectedRelationItemsIds: this.selectedRelationItems.map(item => item.id),
                        isEditTextParams: false,
                    })
                    .then(() => {
                        textsGameItems
                            .getItemsByRequest({
                                locale: this.user.locale,
                                page: this.page,
                                access: this.selectedTextsAccess,
                            })
                            .then(data => {
                                this.lastPage = data.lastPage;
                                this.texts = data.data;
                                this.texts.forEach(text => {
                                    text.questions = JSON.parse(text.questions);
                                });
                                this.loadingTextItems = false;
                            });
                        this.showTextSettings = false;
                        this.selectedText = null;
                        this.relation = '';
                        this.relationItems = [];
                    })
                    .catch(() => {
                        this.showTextSettings = false;
                        this.selectedText = null;
                        this.relation = '';
                        this.relationItems = [];
                        this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                    });
            },
            closeTextSettings() {
                this.showTextSettings = false;
                this.selectedText = null;
                this.relation = '';
                this.relationItems = [];
            },
            handleTextSettings(text) {
                this.closeSelectTextModal();
                this.showTextSettings = true;
                this.selectedText = text;
                if (this.selectedText.grades && this.selectedText.grades.length) {
                    this.relation = 'grade';
                    this.$nextTick(() => {
                        this.selectedRelationItems = this.selectedText.grades;
                    });
                }
                if (this.selectedText.schools && this.selectedText.schools.length) {
                    this.relation = 'school';
                    this.$nextTick(() => {
                        this.selectedRelationItems = this.selectedText.schools;
                    });
                }
            },
            handleDeleteText(text) {
                this.closeSelectTextModal();
                this.showDeleteTextModal = true;
                this.selectedTextId = text.id;
            },
            getLocaleName(locale) {
                return this.localeNames[locale];
            },
            getAmountOfWordsName(amount) {
                if (amount === 'any') {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_any');
                }
                return amount;
            },
            handleGameSave() {
                if (this.saveToDB) {
                    let paramsForRequest = {
                        content: this.params.sourceText,
                        questions: JSON.stringify(this.params.questions),
                        locale: this.params.language,
                        label: this.params.textLabel,
                        relation: this.relation,
                        selectedRelationItemsIds: this.selectedRelationItems.map(item => item.id),
                    };
                    textsGameItems.saveTextToDB(paramsForRequest).catch(err => this.$toasted.error(err));
                }
                if (this.editText) {
                    let paramsForRequest = {
                        content: this.params.sourceText,
                        questions: JSON.stringify(this.params.questions),
                        locale: this.params.language,
                        label: this.params.textLabel,
                        relation: this.relation,
                        selectedRelationItemsIds: this.selectedRelationItems.map(item => item.id),
                        isEditTextParams: true,
                        id: this.selectedTextId,
                    };
                    textsGameItems.updateTextData(paramsForRequest).catch(err => this.$toasted.error(err));
                }
                !this.usersIds && this.gameMode && this.gameMode === FREE_GAME ? this.saveGameMode() : this.saveGame();
            },
            deleteText() {
                textsGameItems
                    .deleteText(this.selectedTextId)
                    .then(data => {
                        this.$toasted.success(this.$i18n.t('trainer.trainer_gameFormSetting_textDeleted'));
                        this.availableTextsAccesses = data.availableTextsAccesses;
                        if (!this.availableTextsAccesses.includes(this.selectedTextsAccess)) {
                            this.selectedTextsAccess = this.availableTextsAccesses[0];
                        }
                        const deletedTextIndex = this.texts.findIndex(text => text.id === this.selectedTextId);
                        this.texts.splice(deletedTextIndex, 1);
                    })
                    .catch(err => {
                        this.$toasted.error(err);
                    });
                this.showDeleteTextModal = false;
            },
            setDefaultParameters() {
                this.gameModes = this.gameModes.filter(item => this.courseParameters.mode.includes(item.mode));
            },
            setSentenceSettings(key, value) {
                if (this.params.settings[key] === value) {
                    this.params.settings[key] = false;
                } else if (
                    this.params.settings[key] &&
                    this.params.settings[key][this.params.settings[key].length - 1] === value &&
                    this.gameMode !== 'course'
                ) {
                    this.params.settings[key] = this.params.settings[key].slice(
                        0,
                        this.params.settings[key].length - 1
                    );
                } else {
                    if (key === 'endLetters') {
                        this.params.settings[key] = value;
                        if (this.gameMode !== 'course') {
                            this.params.settings.centralLetters = false;
                        }
                    } else if (key === 'centralLetters') {
                        this.params.settings[key] = value;
                        if (this.gameMode !== 'course') {
                            this.params.settings.endLetters = false;
                        }
                    }
                }
            },
            setTextSettings(key, value) {
                if (this.params.settings[key] === value) {
                    this.params.settings[key] = false;
                } else if (
                    this.params.settings[key] &&
                    this.params.settings[key][this.params.settings[key].length - 1] === value
                ) {
                    this.params.settings[key] = this.params.settings[key].slice(
                        0,
                        this.params.settings[key].length - 1
                    );
                } else {
                    if (key === 'mirrorText') {
                        this.params.settings[key] = value;
                        if (this.gameMode !== 'course') {
                            this.params.settings.invertText = false;
                            this.params.settings.anagrams = null;
                        }
                    } else if (key === 'invertText') {
                        this.params.settings[key] = value;
                        if (this.gameMode !== 'course') {
                            this.params.settings.mirrorText = null;
                            this.params.settings.anagrams = null;
                        }
                    }
                }
            },
            setSettings(key, value) {
                if (this.params.settings[key] === value) {
                    this.params.settings[key] = null;
                } else {
                    this.params.settings[key] = value;
                }
                if (key === 'anagrams' && this.gameMode !== 'course') {
                    this.params.settings.mirrorText = null;
                    this.params.settings.invertText = false;
                }
            },
            closeManualInputModal() {
                this.params.sourceText = '';
                this.params.textLabel = '';
                this.saveToDB = false;
                this.editText = false;
                this.showManualInputModal = false;
                this.relation = '';
                this.selectedRelationItems = [];
            },
            closeSelectTextModal() {
                this.params.sourceText = '';
                this.params.textLabel = '';
                this.saveToDB = false;
                this.editText = false;
                this.relation = '';
                this.selectedRelationItems = [];
                this.showSelectTextModal = false;
            },
            handleClickOnText(text) {
                this.params.sourceText = text.content;
                this.params.textLabel = text.label;
                this.params.questions = text.questions;
                if (text.schools.length) {
                    this.relation = 'school';
                    this.$nextTick(() => {
                        this.selectedRelationItems = text.schools;
                    });
                } else if (text.grades.length) {
                    this.relation = 'grade';
                    this.$nextTick(() => {
                        this.selectedRelationItems = text.grades;
                    });
                }
                this.showSelectTextModal = false;
                this.saveToDB = false;
                this.editText = false;
                this.canUserEditText = text.canUserEditText;
                this.selectedTextId = text.id;
            },
            addAnswer(index) {
                this.params.questions[index].answers.push({
                    content: '',
                    correct: false,
                });
            },
            addQuestion() {
                this.params.questions.push({
                    content: '',
                    answers: [
                        {
                            content: '',
                            correct: true,
                        },
                        {
                            content: '',
                            correct: false,
                        },
                    ],
                });
            },
            deleteQuestion(index) {
                this.params.questions.splice(index, 1);
            },
            deleteAnswer(answerIndex, questionIndex) {
                this.params.questions[questionIndex].answers.splice(answerIndex, 1);
            },
            setRightAnswer(answer, index) {
                this.params.questions[index].answers.forEach(answer => {
                    answer.correct = false;
                });
                answer.correct = true;
            },
            resizeText(index) {
                if (this.openedTexts.includes(index)) {
                    this.openedTexts.splice(this.openedTexts.indexOf(index), 1);
                } else {
                    this.openedTexts.push(index);
                }
            },
            isTextOpened(index) {
                return this.openedTexts.includes(index);
            },
            lines(text) {
                return text.content.split('\n');
            },
            isChecked(number, setting) {
                if (this.params.settings[setting]) {
                    if (
                        number.mode <= this.params.settings[setting].mode ||
                        this.params.settings[setting].mode === 'all'
                    ) {
                        return true;
                    }
                }
            },
            selectGameMode(mode) {
                if (this.gameMode === 'course') {
                    this.$nextTick(() => {
                        this.params.mode = this.selectedGameMode.map(item => item.mode);
                    });
                } else {
                    this.params.mode = mode;
                }
            },
            isDisabled(number, setting) {
                if (this.courseParameters) {
                    if (this.courseParameters.settings[setting]) {
                        if (this.courseParameters.settings[setting].mode === 'all') {
                            return false;
                        }
                        return this.courseParameters.settings[setting].mode < number.mode || number.mode === 'all';
                    }
                    return true;
                }
                return false;
            },
            updateMetronomeSpeed(value) {
                this.params.metronomeSpeed = +value;
            },
            getRelationName(relation) {
                return this.relations[relation];
            },
            getRelationItems() {
                if (
                    (this.relationItemsType === this.relation && this.relationItems.length) ||
                    (!this.selectedText && !this.showManualInputModal)
                ) {
                    return;
                }
                this.loadingRelationItems = true;
                let api = this.relation === 'school' ? SchoolApi : GradeApi;
                let params =
                    this.relation === 'school'
                        ? { all: true, withActiveAccount: true }
                        : {
                              schoolId: this.user.isSuperadmin ? null : this.user.school && this.user.school.id,
                              schoolsIds: this.user.isSuperadmin
                                  ? null
                                  : this.user.schools && this.user.schools.map(school => school.id),
                              status: 'active',
                              all: true,
                              access: this.slug === 'Texts' ? 'fastReading' : 'onlineSchool',
                              withoutWith: true,
                          };
                api.list(params)
                    .then(data => {
                        let items = this.relation === 'school' ? data.schools : data.grades;
                        this.relationItems = items ? items : [];
                        this.loadingRelationItems = false;
                    })
                    .catch(() => {
                        this.loadingRelationItems = false;
                        this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                    });
            },
            speedLabel(speed) {
                return speed.value + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_wordsPerMinute');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .link {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
            cursor: pointer;
        }
    }

    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__field-body--inline {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .form__multiselect-container {
        flex: 1 1 auto;
    }

    .form__multiselect-container:not(:last-child) {
        margin-right: 10px;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }

    .source-text {
        margin-top: 12px;
    }

    .trainer-modal__footer {
        display: flex;
        button {
            width: 100%;
        }
    }

    .modal-label {
        font-weight: bold;
        padding-right: 8px;
    }

    .trainer-modal-content,
    .trainer-modal-button {
        margin-top: 20px;
    }

    .trainer-modal-content {
        min-height: 50vh;
    }

    .trainer-modal-content__noTextsMessage {
        text-align: center;
        font-size: 24px;
        margin-top: 8%;
    }

    .trainer-modal-content__textarea {
        height: 250px;
        display: block;
        line-height: 1.25;
        max-height: 600px;
        max-width: 100%;
        min-width: 100%;
        padding: 0.8em;
        resize: vertical;
        &_small {
            height: 65px;
            display: block;
            line-height: 1.25;
            max-height: 600px;
            max-width: 100%;
            min-width: 100%;
            padding: 0.8em;
            resize: vertical;
        }
    }

    .question-block__input__icon,
    .answer-block__input__icon {
        position: relative;
        display: block;
        left: calc(100% - 16px);
        width: 0;
        height: 0;
    }

    .question-block__input {
        position: relative;
    }

    .answer-block {
        margin-top: 25px;
    }

    .answer-block__items {
        display: flex;
    }

    .answer-block__input {
        width: 100%;
        position: relative;
    }

    .right-answer-checkbox {
        margin-right: 10px;
    }

    .delete-answer-icon,
    .delete-question-icon {
        position: absolute;
        top: 0;
        right: 0;
        color: $hsl-color-blue-56;
        &:hover {
            color: $hsl-color-red-62;
        }
        cursor: pointer;
    }

    .input-area {
        border: 1px solid #bdbdbd;
        box-sizing: border-box;
        border-radius: 5px;
        &:focus,
        &:active {
            outline: none;
        }
        &::placeholder {
            font-weight: lighter;
        }
        @media screen and (max-width: 767px) {
            max-width: 205px;
        }
    }

    .answer-button {
        display: flex;
        margin-bottom: 40px;
        @media screen and (max-width: 767px) {
            flex-direction: column;
        }
    }

    .select-correct-answer-text {
        font-size: 16px;
        line-height: 19px;
        text-align: right;
        color: #828282;
        @media screen and (max-width: 767px) {
            margin-bottom: 10px;
        }
    }

    .trainer-modal__save-to-database {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .trainer-modal-content__text-item {
        border-radius: 10px;
        cursor: pointer;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: #333333;
        box-sizing: border-box;
        max-width: 475px;
        margin: 0 auto 20px auto;
        &_opened {
            border: 1px solid #f2f2ff;
        }
        &_selected {
            background: #f2fff2;
            border: 1px solid #6bbd6c;
        }
    }

    .text-content {
        background: #ffffff;
        border: 1px solid #f2f2ff;
        border-top: none;
        box-sizing: border-box;
        border-radius: 0 0 10px 10px;
        &_selected {
            background: #f2fff2;
        }
    }

    .trainer-modal-content__text-item__title {
        padding: 20px;
        border-radius: 10px;
        border: 1px solid #f2f2ff;
        background: #f2f2ff;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        &_selected {
            background: #f2fff2;
            border-bottom: 1px solid #6bbd6c;
        }
        &_closed {
            border-bottom: none;
        }
    }

    .trainer-modal-content__text-item__answers {
        padding-left: 10px;
    }

    .trainer-modal-content__text-item__answer {
        display: inline-flex;
    }

    .trainer-modal-content__text-item__answer__correct {
        margin-left: 5px;
    }

    .trainer-modal-content__text-item__answer__correct__box {
        content: '';
        position: relative;
        left: 0;
        width: 1.2rem;
        min-width: 1.2rem;
        height: 1.2rem;
        margin-right: 0.3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #6bbd6c;
    }

    .trainer-modal-content__text-item__resize__box {
        content: '';
        position: relative;
        top: 0.2rem;
        left: 0.4rem;
        width: 1.2rem;
        min-width: 1.2rem;
        height: 1.2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: $hsl-color-blue-56;
    }

    .trainer-modal-content__text-item-settings {
        display: flex;
        align-items: center;
        justify-content: center;
        color: $hsl-color-blue-56;
        border: 1px solid $hsl-color-blue-56;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        &:hover {
            background: $hsl-color-blue-56;
            color: #ffffff;
        }
    }

    .trainer-modal-content__text-item-delete {
        display: flex;
        margin-left: 5px;
        align-items: center;
        justify-content: center;
        color: $hsl-color-blue-56;
        border: 1px solid $hsl-color-blue-56;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        &:hover {
            background: $hsl-color-blue-56;
            color: #ffffff;
        }
    }

    .trainer-modal-content__text-item-actions {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .add-answer-button {
        margin-left: auto;
        margin-right: 0;
    }

    .add-question-button {
        button {
            width: 100%;
        }
    }

    .add-button-block {
        content: '';
        position: relative;
        left: 0;
        width: 1.5rem;
        min-width: 1.5rem;
        height: 1.5rem;
        border-radius: 50%;
        background: white;
        border: 2px solid lightgrey;
        margin-right: 0.3rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .button_with-margin {
        margin-right: 5px;
    }

    .save-text-relation-selector {
        margin-top: 0.5rem;
    }

    .trainer-modal-content__settings {
        max-width: 475px;
        margin: 0 auto;
    }

    .trainer-modal-content__setting {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0;
        position: relative;
        &:last-child {
            margin-bottom: 30px;
            justify-content: space-between;
        }
        &:first-child {
            justify-content: space-between;
        }
        @media screen and (max-width: 767px) {
            flex-direction: column;
            text-align: left;
            align-items: stretch;
        }
    }

    .text-settings {
        max-width: 320px;
        margin-left: 20px;
        @media screen and (max-width: 767px) {
            margin-left: 0;
        }
    }

    .trainer-modal-content__access-selector-buttons {
        display: flex;
        width: 100%;
    }

    .cs-button-selector {
        line-height: 14px !important;
        font-size: 16px;
        width: 100%;
        &:first-child {
            border-radius: 40px 0 0 40px;
        }
        &:last-child {
            border-radius: 0 40px 40px 0;
        }
        &_active {
            background-color: $hsl-color-blue-48 !important;
            color: #ffffff !important;
        }
    }

    .trainer-modal-content__search-input {
        width: 100%;
    }

    .search-icon {
        right: 15px;
        position: absolute;
        top: 25%;
        color: #bdbdbd;
        cursor: pointer;
    }

    .text-settings__select {
        margin: 20px 0;
    }

    .text-label {
        font-weight: 500;
        font-size: 20px;
        line-height: 24px;
        color: #333333;
        display: flex;
        align-items: center;
    }

    .trainer-modal-content__text-item__content {
        font-size: 16px;
        line-height: 24px;
        color: #333333;
        text-align: left;
        padding: 0 10px 0 10px;
        &:first-child {
            padding-top: 20px;
        }
    }

    .trainer-modal-content__text-item__question {
        &:first-child {
            padding-top: 25px;
        }
        padding: 20px 10px 10px 10px;
    }

    .answer,
    .question {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: #333333;
    }
    .question {
        margin-bottom: 15px;
    }

    .trainer-modal-content__text-item__questions {
        text-align: left;
        &_last {
            margin-bottom: 30px;
        }
    }

    .trainer-modal-content__amount-of-words-selector {
        white-space: nowrap;
    }

    .selected-text-icon {
        color: #6bbd6c;
        margin-right: 10px;
    }

    .trainer-modal-content__text-settings {
        height: 250px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .settings-row {
        margin: 0;
        flex-direction: column;
        flex-wrap: wrap;
    }

    .settings-header {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #333333;
        margin-bottom: 15px;
    }

    .form-container__setting {
        display: flex;
        margin-bottom: 30px;
        align-items: center;
        width: 100%;
        flex-wrap: wrap;
    }

    .form-container__select {
        max-width: 120px;
        @media screen and (max-width: 575px) {
            max-width: 100%;
        }
    }

    .setting__checkbox {
        margin-right: 40px;
        @media screen and (max-width: 991px) {
            margin-bottom: 30px !important;
        }
        @media screen and (max-width: 575px) {
            margin-bottom: 40px !important;
        }
    }

    .trainer-modal-content__verification-button {
        padding: 5px;
    }

    .trainer-modal-content__footer-button {
        margin: 5px;
    }
</style>
